import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../lib/redux/hooks"
import { formatterDate, getNotificationLabelByValue, } from "../../../utils"

export function MonitoringValutazioniListVisits() {
    const dispatch = useAppDispatch()
    const navigate = useNavigate()
    const valutazioneState = useAppSelector(state => state.valutazioniMonitoring)

    return (
        <div className="mt-6">
            <table id="users-table" className="w-[100%]">
                <thead className="h-[52px] uppercase">
                    <tr>
                        <th style={{ borderTopLeftRadius: '8px' }}>Sede</th>
                        <th>Rif Norma</th>
                        <th>Cod. Op</th>
                        <th>Ciente</th>
                        <th>Utente Validazione</th>
                        <th>Data Visita</th>
                        <th style={{ borderTopRightRadius: '8px' }}>Data Validazione Visita</th>
                    </tr>
                </thead>
                <tbody>
                    {
                        valutazioneState.GetAllValutazioniResponse?.map((fs, index) => (
                            <tr
                                key={index}
                                style={{
                                    color: '#4D797F',
                                    background: index % 2 === 0 ? '#F2F7F7' : '#FFFFFF'
                                }}
                            >
                                <td>{fs.customerHeadQuarters}</td>
                                <td>{fs.norm}</td>
                                <td>{fs.customerClientCode}</td>
                                <td>{fs.customerCompanyName}</td>
                                <td>{fs.validationVisitUser}</td>
                                <td>{formatterDate(fs.visitDate)}</td>
                                <td>{formatterDate(fs.validationVisitDate)}</td>
                                
                            </tr>
                        ))}

                </tbody>
            </table>
        </div>
    )
}